"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _themes = require("./themes");

var _styles = require("@mui/material/styles");

var _classnameGenerator = require("./classname-generator");

var _global = _interopRequireDefault(require("global"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * If the theme has not been registered, it creates a new theme and saves it to
 * the registry. Otherwise it returns a matching existing theme
 *
 * @param {Object} props
 * @param {string} [props.baseThemeName] - Name of the base theme name to use
 * @param {string} [props.prefix] - Theme prefix
 * @param {...*} [additionalThemeOptions] - Additional arguments to deep merge with MUI theme
 */
var getThemeProviderProps = function getThemeProviderProps(_ref) {
  var baseThemeName = _ref.baseThemeName,
      prefix = _ref.prefix,
      additionalThemeOptions = _ref.additionalThemeOptions;
  var registeredTheme = _global.default.adsk.dhig2021.themeRegistry[prefix]; // Verify if a theme has been created for the current theme provider instance

  if (!registeredTheme) {
    var getThemeObject = _themes.themes[baseThemeName];

    var _getThemeObject = getThemeObject(_objectSpread({}, additionalThemeOptions)),
        themeObject = _getThemeObject.theme;

    (0, _classnameGenerator.configureClassnameGenerator)({
      prefix: prefix
    });

    var _theme = (0, _styles.createTheme)(themeObject, additionalThemeOptions);

    _global.default.adsk.dhig2021.themeRegistry[prefix] = {
      baseThemeName: baseThemeName,
      theme: _theme
    };
  }

  var theme = _global.default.adsk.dhig2021.themeRegistry[prefix].theme;
  return {
    theme: theme
  };
};
/**
 * MUI theme wrapper
 *
 * @param {Object} props
 * @param {string} [props.baseThemeName=dhig2021] - Name of the base theme name to use
 * @param {JSX.Element} props.children
 * @param {string} [props.themePrefix] - Optional prefix to add to generated classnames
 * @param {...*} [additionalThemeOptions] - Additional options to deep merge with MUI theme
 */


var ThemeMui = function ThemeMui(_ref2) {
  var _window$adsk, _window$adsk$dhig, _window$adsk$dhig2;

  var _ref2$baseThemeName = _ref2.baseThemeName,
      baseThemeName = _ref2$baseThemeName === void 0 ? "dhig2021" : _ref2$baseThemeName,
      children = _ref2.children,
      themePrefix = _ref2.themePrefix,
      additionalThemeOptions = _objectWithoutProperties(_ref2, ["baseThemeName", "children", "themePrefix"]);

  if (Object.keys(additionalThemeOptions).length && !themePrefix) {
    throw "If extending Material UI theme, you must provide a unique theme prefix";
  } // Initialize an array to record existing themes on current document


  if (!((_window$adsk = _global.default.adsk) !== null && _window$adsk !== void 0 && (_window$adsk$dhig = _window$adsk.dhig2021) !== null && _window$adsk$dhig !== void 0 && _window$adsk$dhig.themeRegistry)) {
    _global.default.adsk = _global.default.adsk || {};
    _global.default.adsk.dhig2021 = _global.default.adsk.dhig2021 || {};
    _global.default.adsk.dhig2021.themeRegistry = {};
  } // Select the theme that gets the privilege to be injected without a prefix


  var unprefixedThemeName = ((_window$adsk$dhig2 = _global.default.adsk.dhig2021.themeRegistry[""]) === null || _window$adsk$dhig2 === void 0 ? void 0 : _window$adsk$dhig2.baseThemeName) || baseThemeName; // Prefix algorithm
  // Empty for the first theme injected into the document
  // Theme prefix if provided by user
  // Defaults to base theme name otherwise

  var prefix = baseThemeName === unprefixedThemeName && !themePrefix ? "" : themePrefix || baseThemeName;

  var _getThemeProviderProp = getThemeProviderProps({
    baseThemeName: baseThemeName,
    prefix: prefix,
    additionalThemeOptions: additionalThemeOptions
  }),
      theme = _getThemeProviderProp.theme;

  return /*#__PURE__*/_react.default.createElement(_styles.StyledEngineProvider, {
    injectFirst: true
  }, /*#__PURE__*/_react.default.createElement(_styles.ThemeProvider, {
    theme: theme
  }, children));
};

ThemeMui.propTypes = {
  /**
   * The Material UI theme name to use as base
   */
  baseThemeName: _propTypes.default.oneOf(Object.keys(_themes.themes)),

  /**
   * The content to wrap in the ThemeProvider.
   */
  children: _propTypes.default.any.isRequired,

  /**
   * An arbitrary theme prefix. Defaults to baseThemeName. Required if Material UI theme extensions are provided.
   */
  themePrefix: _propTypes.default.string
};
ThemeMui.__docgenInfo = {
  "description": "MUI theme wrapper\n\n@param {Object} props\n@param {string} [props.baseThemeName=dhig2021] - Name of the base theme name to use\n@param {JSX.Element} props.children\n@param {string} [props.themePrefix] - Optional prefix to add to generated classnames\n@param {...*} [additionalThemeOptions] - Additional options to deep merge with MUI theme",
  "methods": [],
  "displayName": "ThemeMui",
  "props": {
    "baseThemeName": {
      "defaultValue": {
        "value": "\"dhig2021\"",
        "computed": false
      },
      "type": {
        "name": "enum",
        "computed": true,
        "value": "Object.keys(themes)"
      },
      "required": false,
      "description": "The Material UI theme name to use as base"
    },
    "children": {
      "type": {
        "name": "any"
      },
      "required": true,
      "description": "The content to wrap in the ThemeProvider."
    },
    "themePrefix": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "An arbitrary theme prefix. Defaults to baseThemeName. Required if Material UI theme extensions are provided."
    }
  }
};
var _default = ThemeMui;
exports.default = _default;